// Required imports
import { useEffect, RefObject } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to focus on an input element whenever the route changes.
 * @param {RefObject<HTMLInputElement>} inputRef - Ref object pointing to the input element you want to focus on.
 */
const  useFocusOnRouteChange = (inputRef: RefObject<HTMLInputElement>) =>{
    // Obtain the current location object from React Router.
    const location = useLocation();

    useEffect(() => {
        // Check if the inputRef is currently pointing to an element.
        if (inputRef.current) {
            // Focus on the input element.
            inputRef.current.focus();
        }
        // Reacting to changes in the pathname ensures the effect runs
        // every time the route changes.
    }, [location.pathname, inputRef]);  
}

// Export the custom hook for usage in other components.
export default useFocusOnRouteChange;